import React, { useContext } from 'react';
import { Paper, PaperProps } from '@mui/material';
import { ActiveTabContext } from './ActiveTabContext';

export interface TabPanelProps<T extends string> extends PaperProps {
  tabsId: string;
  value: T;
  isPrintMode?: boolean;
  isVisible?: boolean;
}

export function TabPanel<T extends string = string>(props: TabPanelProps<T>) {
  const { children, tabsId, value, isPrintMode, isVisible = true, ...other } = props;
  const activeTab = useContext(ActiveTabContext);

  if (!isVisible) {
    return null;
  }

  return (
    <Paper
      role="tabpanel"
      hidden={value !== activeTab && !isPrintMode}
      id={`${tabsId}-tabpanel-${value}`}
      aria-labelledby={`${tabsId}-tab-${value}`}
      elevation={0}
      variant='outlined'
      square
      sx={{
        padding: 2,
        ...other.sx,
      }}
      {...other}
    >
      {(value === activeTab || isPrintMode) && children}
    </Paper>
  );
}
